module.exports = __webpack_public_path__ + "img/slide-x2.fffbe279.png";